module.exports = __webpack_public_path__ + "static/media/Gmc_Blanc_Petit.d7b8c947.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/Gmc_Blanc_Petit.svg
// module id = 1009
// module chunks = 0